import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ClearTasks } from '@actions/tasks.actions';
import { ClearUploadItems } from '@actions/uploads.actions';

import { BaseBootstrapSandboxService, Logout, UnsetSelection } from '@mediahaven/shared';
import { ApplicationState } from 'state';

@Injectable({ providedIn: 'root' })
export class BootstrapSandboxService extends BaseBootstrapSandboxService {
    // Injectors
    protected override readonly store: Store<ApplicationState> = inject(Store);

    public override clearStore(): void {
        this.cacheInterceptor?.clearCache();
        this.store.dispatch(new Logout());
        this.store.dispatch(new ClearUploadItems());
        this.store.dispatch(new ClearTasks());
        this.store.dispatch(new UnsetSelection());
    }

    protected override buildIsAuthenticatedStream(): Observable<boolean> {
        return this.store.select(state => state.authentication.isAuthenticated);
    }
}
